module.exports = __webpack_public_path__ + "img/outsorsing-banner-bg.a7bfb475.webp";